import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'OrganizedUnit/PutOu', method: 'PUT', body: body, token: token })
}
